import script from "./WCMobileOTSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCMobileOTSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./WCMobileOTSwitcher.vue?vue&type=style&index=0&id=4328e413&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4328e413"]])

export default __exports__